import servicios from "../img/productos/servicios.png"
import servicios1 from "../img/productos/servicios1.png"
import servicios2 from "../img/productos/servicios2.png"
import sembrador from "../img/sembrador.png"
import iconoEnvio from "../img/icon_envio.png"
import iconoPago from "../img/icon_pago.png"
import Cards from "./Cards"

import MobileImg from "../hooks/MobileImg"
import "./css/download-button.css"
import "./css/productos-highlight.css"
import { getAllProductsUrl } from "../utils/routes"

const Productos = () => {
  const handleViewAllProducts = () => {
    const targetUrl = getAllProductsUrl()
    if (typeof window !== "undefined") {
      window.location.assign(targetUrl)
    }
  }

  return (
    <section className="all-section-container overflow-hidden productos-section">
      <div id="Productos" data-aos="fade-right">
        <div className="section-productos">
          <div style={{ width: "70%", margin: "0 auto" }}>
            <MobileImg className="srvs" servicios={servicios} servicios1={servicios1} servicios2={servicios2} />
          </div>

          <Cards />
          <section className="productos-highlight" aria-label="Nuestros productos">
            <div className="productos-highlight__image">
              <img src={sembrador} alt="Agricultor caminando por un sembradío" loading="lazy" />
            </div>

            <div className="productos-highlight__content">
              <h3 className="productos-highlight__title">NUESTROS PRODUCTOS</h3>
              <p className="productos-highlight__description">
                Contamos con los productos agrícolas más confiables del mercado, diseñados para cumplir con los estándares de
                calidad más exigentes, garantizando rendimiento y eficiencia para tu producción.
              </p>

              <ul className="productos-highlight__benefits">
                <li>
                  <img src={iconoEnvio} alt="Icono de envío" loading="lazy" />
                  <span>Envíos a todo el país</span>
                </li>
                <li>
                  <img src={iconoPago} alt="Icono de pago" loading="lazy" />
                  <span>Pagas al recibir</span>
                </li>
              </ul>

              <button type="button" className="view-all-products-button" onClick={handleViewAllProducts}>
                Ver todos los productos
              </button>
            </div>
          </section>
        </div>
      </div>
    </section>
  )
}

export default Productos
